import useIsAppleDevice from 'hooks/useIsAppleDevice';
import React, { FC } from 'react';
import AppStoreImage from 'assets/images/appstore_updated.png';
import GoogleStoreImage from 'assets/images/google-play_updated.png';
import { ButtonNativeApp } from 'store/landing/types';
import { useLandingPageContext } from 'context/LandingPageContext';
import styles from './MessageCardGroupNativeButtons.module.scss';

const APP_STORE = 'https://go.onelink.me/app/8a7a5144';
const GOOGLE_STORE = 'https://go.onelink.me/app/6a41de3b';

export interface MessageCardGroupNativeButtonsProps {
  buttonNativeApp?: ButtonNativeApp;
}

const MessageCardGroupNativeButtons: FC<MessageCardGroupNativeButtonsProps> = ({ buttonNativeApp }) => {
  const { isDesktopDevice } = useLandingPageContext();
  const isAppleDevice = useIsAppleDevice();

  return (
    <div className={styles.container}>
      {buttonNativeApp?.text && <div className={styles.title}>{buttonNativeApp?.text}</div>}
      <div className={styles.buttonContainer}>
        {isDesktopDevice && (
          <>
            <a href={APP_STORE} target="_blank" rel="noreferrer">
              <img src={AppStoreImage} alt="App store button" />
            </a>
            <a href={GOOGLE_STORE}>
              <img src={GoogleStoreImage} alt="Google store button" />
            </a>
          </>
        )}
        {!isDesktopDevice && (
          <>
            {isAppleDevice && (
              <a href={APP_STORE} target="_blank" rel="noreferrer">
                <img src={AppStoreImage} alt="App store button" />
              </a>
            )}
            {!isAppleDevice && (
              <a href={GOOGLE_STORE}>
                <img src={GoogleStoreImage} alt="Google store button" />
              </a>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MessageCardGroupNativeButtons;
